import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const api_Url = process.env.NEXT_PUBLIC_API_URL || "https://api.itsonlyonestop.com";


export const createCustomOfferThunk = createAsyncThunk(
    "create-custom-offer",
    async ({ data, token }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${api_Url}/api/create-custom-offer`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response?.data;
        } catch (error) {
            console.log("error:", error);
            return rejectWithValue(error?.response?.data || "Unknown error");
        }
    }
);

export const getOfferListThunk = createAsyncThunk(
    "get-order-list",
    async ({ token, params }) => {
        try {
            const response = await axios.get(`${api_Url}/api/get-offer-list`, {
                params,
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response?.data;
        }
        catch (error) {
            console.log("error:", error)
        }
    });

export const getOfferDetailsThunk = createAsyncThunk(
    "get-order-details",
    async ({ token, params }) => {
        try {

            const response = await axios.get(`${api_Url}/api/get-offer-details`, {
                params,
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response?.data;
        }
        catch (error) {
            console.log("error:", error)
        }
    });

export const changeOfferStatusThunk = createAsyncThunk(
    "offer-status-change",
    async ({ token, data }) => {
        try {
            const response = await axios.post(
                `${api_Url}/api/offer-status-change`, data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return response?.data;
        } catch (error) {
            console.log(error);
        }
    }
);
